import React from 'react';
import { Grid, GridProps } from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

interface IGridCurrencyFieldProps extends GridProps {
  label: string;
  onFieldChange: (ev: any, value: any) => void;
  value: number | undefined;
  error?: boolean;
  readOnly?: boolean;
  required?: boolean;
}

const GridCurrencyField: React.FC<IGridCurrencyFieldProps> = props => {

  const { label, value, error, readOnly, required, onFieldChange, ...gridProps } = props;

  return (
    <Grid item {...gridProps}>
      <CurrencyTextField
        label={label}
        value={value}
        outputFormat="number"
        currencySymbol="CHF"
        onChange={onFieldChange}
        decimalCharacter="."
        digitGroupSeparator="'"
        error={error}
        minimumValue="0"
        disabled={readOnly}
        required={required}
        fullWidth
      />
    </Grid>)
}

export default GridCurrencyField